import React, { useState, useEffect } from "react";
import InputField from "../../components/InputField";
import Switch from "../../components/Switch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import ToolTip from "../ToolTip";
import Dropdown from "../Dropdown";

const DeviceForm = ({
  device,
  setDevice,
  setHasChanges,
  billingGroups,
  accountTypes,
  onBillingGroupChange,
  onAccountTypeChange,
}) => {
  const [selectedBillingGroup, setSelectedBillingGroup] = useState("");
  const [selectedAccountType, setSelectedAccountType] = useState("");

  useEffect(() => {
    if (device?.billingGroupId) {
      const billingGroup = billingGroups.find((b) => {
        return b.billingGroupId == device.billingGroupId;
      });

      setSelectedBillingGroup(billingGroup?.name);
    }

    if (device?.accountTypeId) {
      const accountType = accountTypes.find((a) => {
        return a.accountTypeId == device.accountTypeId;
      });
      setSelectedAccountType(accountType?.name);
    }
  }, [device, billingGroups, accountTypes]);

  return (
    <>
      {/* Two-column layout */}
      <div className="grid grid-cols-2 gap-6 w-full">
        {/* Column 1 */}
        <div className="flex flex-col gap-4">
          {/*           <Dropdown
            label="Billing group"
            value={selectedBillingGroup}
            options={billingGroups || [].map((group) => group.name)}
            onSelect={(option) => {
              const selectedGroup = billingGroups.find(
                (g) => g.name === option
              );
              if (!selectedGroup) return;

              setSelectedBillingGroup(option);

              setDevice((prev) => ({
                ...prev,
                billingGroupId: selectedGroup.billingGroupId,
                billingGroupPublicId: selectedGroup.billingGroupPublicId,
                billingGroupName: selectedGroup.name,
              }));

              setHasChanges(true);
            }}
            disabled={false}
          /> */}

          {/*           <Dropdown
            label="Account type"
            value={selectedAccountType}
            options={accountTypes || [].map((type) => type.name)}
            onSelect={(option) => {
              const at = accountTypes.find((g) => g.name === option);
              if (!at) return;

              setSelectedAccountType(option);

              setDevice((prev) => ({
                ...prev,
                accountTypeId: at.accountTypeId,
                accountTypeName: at.name,
              }));

              setHasChanges(true);
            }}
            disabled={false}
          /> */}

          <InputField
            label="Product url"
            placeholder="Product url"
            value={device?.productUrl || ""}
            onChange={(e) => {
              setDevice((s) => ({ ...s, productUrl: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={false}
          />
        </div>

        {/* Column 2 */}
        <div className="flex flex-col gap-4">
          <InputField
            label="Name"
            placeholder="Name"
            value={device?.displayName || ""}
            onChange={(e) => {
              setDevice((s) => ({ ...s, displayName: e.target?.value }));
              setHasChanges(true);
            }}
            readOnly
            className="w-full"
            disabled={false}
          />
        </div>
      </div>
    </>
  );
};

export default DeviceForm;
